import { combineReducers } from 'redux';

import ProfileTypes from './types';

export const profileReducer = combineReducers({
  banks: ProfileTypes.banks.getReducer(),
  accounts: ProfileTypes.accounts.getReducer(),
  myProfile: ProfileTypes.myProfile.getReducer(),
  addressByZipCode: ProfileTypes.addressByZipCode.getReducer(),
  createAccount: ProfileTypes.createAccount.getReducer(),
  isNewbie: ProfileTypes.isNewbie.getReducer(),
  saveTourAction: ProfileTypes.saveTourAction.getReducer(),
  checkPassword: ProfileTypes.checkPassword.getReducer(),
});
